<template>
  <v-container fill-height fluid grid-list-lg class="pa-3">
    <v-layout row wrap>
      <v-flex xs12 md3 :style="{height:blockHeight, 'overflow-y':'auto'}">
        <v-card height="100%">
          <v-system-bar window dark color="accent" style="width: 100%">
            <v-icon center>mdi-format-list-bulleted-type</v-icon>
            <v-toolbar-title class="ml-1">Справочник статусов</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip top>
              <v-btn icon slot="activator" @click="openStatusForm(null)" class="mx-0"><v-icon class="mx-0">mdi-plus</v-icon></v-btn>
              <span>Добавить статус</span>
            </v-tooltip>
            <v-tooltip top>
              <v-btn small icon slot="activator" @click="openFolderForm(null)" class="mx-0"><v-icon class="mx-0">mdi-folder-plus</v-icon></v-btn>
              <span>Создать новую папку</span>
            </v-tooltip>
          </v-system-bar>
          <v-card-text class="objects-list px-0 py-2">
            <v-text-field class="mx-2 mt-0 mb-2 pt-0" v-model="search" label="Фильтр" hide-details single-line clearable clear-icon="mdi-close-circle-outline"></v-text-field>
            <v-treeview :items="statusesTree" item-key="key" class="densed pb-1 ovflowxscroll" :search="search">
              <template slot="prepend" slot-scope="{ item, open, leaf }">
                <v-icon size="20" class="mx-0" :color="item.color" @contextmenu="openMenu($event, item)">{{item.icon}}</v-icon>
              </template>
              <label slot="label" class="pointer" slot-scope="{item}" @contextmenu="openMenu($event, item)" @click.stop="">{{item.name}}</label>
            </v-treeview>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  
    <v-menu v-model="menu.show" :position-x="menu.x" :position-y="menu.y" absolute offset-y>
      <v-list id="org-context-menu">
        <v-list-tile @click="infoItem">
          <v-list-tile-action><i class="mdi mdi-information"></i></v-list-tile-action>
          <v-list-tile-title>Информация</v-list-tile-title>
        </v-list-tile>
        <v-list-tile v-if="currentObject.id !== 0" @click="editItem">
          <v-list-tile-action><i class="mdi mdi-pencil"></i></v-list-tile-action>
          <v-list-tile-title>Редактировать</v-list-tile-title>
        </v-list-tile>
        <v-list-tile v-if="currentObject.element_type ==='folder'" @click="openFolderForm(null, currentObject.id)">
          <v-list-tile-action><i class="mdi mdi-folder-plus"></i></v-list-tile-action>
          <v-list-tile-title>Добавить папку</v-list-tile-title>
        </v-list-tile>
        <v-list-tile v-if="currentObject.element_type ==='folder'" @click="openStatusForm(null, currentObject.id)">
          <v-list-tile-action><i class="mdi mdi-plus"></i></v-list-tile-action>
          <v-list-tile-title>Добавить статус</v-list-tile-title>
        </v-list-tile>
        <v-list-tile v-if="currentObject.id !== 0" @click="deleteItem">
          <v-list-tile-action><i class="mdi mdi-delete"></i></v-list-tile-action>
          <v-list-tile-title>Удалить</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
    
    <v-dialog v-model="dialog" max-width="800" scrollable persistent>
      <component :is="currentComponent" v-if="dialog" v-bind="formProps" @close-dialog="dialog=false" @save="saveChanges"></component>
    </v-dialog>
  </v-container>
</template>

<script>
  import {mapState} from 'vuex'
  import { debounce } from 'lodash'
  import FolderForm from './Forms/FolderForm'
  import StatusForm from './Forms/StatusForm'
  import InfoForm from './Forms/InfoForm'
  
  export default {
    name : "Statuses",
    
    computed:{
      blockHeight(){
        return (this.$vuetify.breakpoint.height - 48 - 40 - 30 )+'px'
      },
      accesses(){
        return this.$store.state.app.account.accesses['worksheet'] || {}
      },
      ...mapState(`orgstructure/anketa`, ['statusesTree']),
    },
    
    created(){
      if(!this.accesses.form_access ){
        this.$store.commit(`app/layout/setRouteStatus`, 'accessDenied')
      } else {
        this.$store.dispatch('orgstructure/anketa/getStatuses')
      }
    },
    
    data(){
      return {
        menu:{
          x: 0,
          y: 0,
          show: false
        },
        search: null,
        dialog: false,
        currentComponent: null,
        formProps: {},
        currentObject: {}
      }
    },
    
    methods:{
      openMenu(e, item) {
        e.preventDefault()
        this.currentObject = item
        this.menu.show = false
        this.menu.x = e.clientX
        this.menu.y = e.clientY
        this.$nextTick( () => {
          this.menu.show = true
        })
      },
  
      infoItem(){
        this.currentComponent = InfoForm
        this.formProps = {data: this.currentObject}
        this.dialog = true
      },
      
      editItem(){
        if(this.currentObject.element_type === 'folder'){
          this.openFolderForm(this.currentObject)
        } else if(this.currentObject.element_type === 'status'){
          this.openStatusForm(this.currentObject)
        }
      },
      
      deleteItem(){
        if(this.currentObject.element_type === 'folder'){
          this.$dmsAgree('Вы уверены, что хотите удалить папку и все вложенные элементы?').then( _ => {
            this.$store.dispatch('orgstructure/anketa/deleteStatusFolder', this.currentObject.id).catch( error => {
              let message = 'Возникла ошибка при удалении папки'
              if(error.response && error.response.data.message){
                message = error.response.data.message
              }
              this.$dmsErrorNoty(message)
            })
          })
        } else if(this.currentObject.element_type === 'status'){
          this.$dmsAgree('Вы уверены, что хотите удалить статус?').then( _ => {
            this.$store.dispatch('orgstructure/anketa/deleteStatus', this.currentObject.id).catch( error => {
              let message = 'Возникла ошибка при удалении статуса'
              if(error.response && error.response.data.message){
                message = error.response.data.message
              }
              this.$dmsErrorNoty(message)
            })
          })
        }
      },
      
      openFolderForm(data = null, parent_id = null){
        this.currentComponent = FolderForm
        this.formProps = {parent_id}
        if(data) this.formProps = {data, parent_id, editMode: true}
        this.dialog = true
      },
      
      openStatusForm(data = null, parent_id = null){
        this.currentComponent = StatusForm
        this.formProps = {parent_id}
        if(data) this.formProps = {data, parent_id, editMode: true}
        this.dialog = true
      },
  
      saveChanges(eventData){
      
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/apps/org/components/Anketa/Statuses.vue